import React, { useState, useEffect, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from '@/components/Typography/Text';
import { useTheme } from '@/context/ThemeContext';

function formatTimeLeft(ms) {
  if (ms <= 0) return null;

  const totalSeconds = Math.floor(ms / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const pad = (n) => String(n).padStart(2, '0');

  if (days > 0) {
    return `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

const createStyles = (colors) => StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  timerText: {
    fontVariant: ['tabular-nums'],
    letterSpacing: 0.5,
  },
});

function BannerCountdown({ endsAt, onExpired, textColor, textSize = 's' }) {
  const { colors } = useTheme();
  const styles = useMemo(() => createStyles(colors), [colors]);

  const [timeLeft, setTimeLeft] = useState(() => {
    if (!endsAt) return 0;
    return Math.max(0, new Date(endsAt).getTime() - Date.now());
  });

  useEffect(() => {
    if (!endsAt) return;

    const target = new Date(endsAt).getTime();

    const tick = () => {
      const remaining = Math.max(0, target - Date.now());
      setTimeLeft(remaining);
      if (remaining <= 0) {
        onExpired?.();
      }
    };

    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [endsAt, onExpired]);

  const formatted = formatTimeLeft(timeLeft);
  if (!formatted) return null;

  return (
    <View style={styles.container}>
      <Text
        size={textSize}
        weight="bold"
        style={[styles.timerText, textColor ? { color: textColor } : undefined]}
      >
        {formatted}
      </Text>
    </View>
  );
}

export default React.memo(BannerCountdown);
